module.exports = __webpack_public_path__ + "mt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mt.svg
// module id = 963
// module chunks = 0